import React from "react";
import {  Box } from '@mui/material';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Form, Formik } from "formik";
import CustomRadioGroup from "../../../../common/components/radio-button-component/radio-button-component";
import OnboardedDateFilter from "../../../tenant/tenant-list/tenant-filter-options/onboardeddate-filter";
import "./subscription-report-filter.scss";

const SubscriptionReportFilter = (props: any) => {
  const { setFilterDate } = props;
const [isFilterOpen, setIsFilterOpen] = React.useState(false);

  return (
            <Box className="subscription-report-filter">
              <Box className="user-reports-filter-item" gap={3}>
          <Formik
                    initialValues={{
                      filterItem: "Yes",
                      onBoardedAtStart: null,
                      onBoardedAtEnd: null,
                    }}
                    enableReinitialize
                    // validate={validate}
                    onSubmit={() => {}}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      setFieldValue,
                      handleSubmit,
                      resetForm,
                    }) => {
                      return (
          <Box className="user-reports-filter-item" gap={3}>
            <p>Date</p>
            <Box
              className="filter-value"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              {values?.filterItem  === "Yes" ? "Last 30 days " : "Date range"} 
              {isFilterOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              {isFilterOpen && (
                <Box
                  className="filter-dropdown"
                  onClick={(e) => e.stopPropagation()}
                >

                        <Form
                          className="drawer-content"
                          onSubmit={handleSubmit}
                        >
                          <Box>
                            <CustomRadioGroup
                              name="filterItem"
                              value={values?.filterItem}
                              options={[
                                { label: "Last 30 days", value: "Yes" },
                                { label: "Date range", value: "No" },
                              ]}
                              onChange={(e) => {
                                if (e.target.value === "Yes") {
                                  setFilterDate({});
                                  setFieldValue("onBoardedAtStart", null);
                                  setFieldValue("onBoardedAtEnd", null);
                                }
                                setFieldValue("filterItem", e.target.value);
                              }}
                            />
                            {values?.filterItem === "No" && (
                              <OnboardedDateFilter
                                startDate={values.onBoardedAtStart}
                                endDate={values.onBoardedAtEnd}
                                onDateRangeChange={(start, end) => {
                                  setFilterDate({
                                    start: start ? new Date(start) : null,
                                    end: end ? new Date(end) : null,
                                  });
                                  if (start)
                                    setFieldValue?.("onBoardedAtStart", start);
                                  if (end)
                                    setFieldValue?.("onBoardedAtEnd", end);
                                }}
                                startDateError={
                                  touched?.onBoardedAtStart &&
                                  errors?.onBoardedAtStart
                                    ? String(errors.onBoardedAtStart)
                                    : undefined
                                }
                                endDateError={
                                  touched?.onBoardedAtEnd &&
                                  errors?.onBoardedAtEnd
                                    ? String(errors.onBoardedAtEnd)
                                    : undefined
                                }
                              />
                            )}
                          </Box>
                        </Form>
                </Box>
              )}
            </Box>
          </Box>                      );
                    }}
                    </Formik>
        </Box>
            </Box>
  );
};

export default SubscriptionReportFilter;
